module.exports = __webpack_public_path__ + "img/recipients.6cb3d958.png";